import './index.scss'
import Swal from 'sweetalert2'
import Switch from "react-switch"
import React, { useEffect, useState, FunctionComponent, useLayoutEffect } from 'react'
import withReactContent from 'sweetalert2-react-content'

import { Representative } from 'interfaces/representative'
import ClientService from 'services/v3/clients.service'
import { IoMdCloseCircle } from "react-icons/io"
import { Button } from '../button'

import { Modal } from 'react-bootstrap'
import './index.scss'


export const BaseModal = ({
    children,
    isVisible,
    data,
    onCloseCallback,
    submit,
    title,
    modalBodyStyle,
    dialogClassName

}: any) => {

    //const MySwal = withReactContent(Swal)

    const [modal, setModal] = useState<any>({})
    //const [representatives, setRepresentatives] = useState<Representative[]>([])

    useEffect(() => {
        setModal({
            title: title,
            //id: 'representatives-modal',
            submit: submit,
            styles: {
                maxWidth: '80vw'
            },
            onClose: onCloseCallback
        })
    }, [data, onCloseCallback])

    //  useEffect(() => {
    //      if (data) {
    //          getAll()
    //      }
    //  }, [data])

    // const getAll = () =>
    //     ClientService.sellers(data.id)
    //         .then((response) => setRepresentatives(response.sellers))

    //  const updateStatus = (id: any) =>
    //      ClientService
    //          .deactivate(data.id, id)
    //          .then(getAll)

    //  const changeStatus = (representative: Representative) => {
    //      MySwal.fire({
    //          title: (
    //              <div>
    //                  <p>
    //                      Você irá desativar este vendedor. Deseja continuar?
    //                  </p>
    //                  <hr />
    //              </div>
    //          ),
    //          showCancelButton: true,
    //          cancelButtonText: "Cancelar",
    //          cancelButtonColor: "red"
    //      }).then((res) => {
    //          if (res.isConfirmed) {
    //              updateStatus(representative.id)
    //              return MySwal.fire(<p>Vendedor desativado com sucesso!</p>)
    //          }
    //      })
    //  }

    return (
        <Modal

            // size="sm"

            show={isVisible}
            onHide={onCloseCallback}
            animation={true}
            dialogClassName={dialogClassName ? dialogClassName : "modal-90w"}>



            <div className='modalHeader'>
                <h2 className='modalTitle'>{modal.title}</h2>
                <div>

                    <IoMdCloseCircle className={'closeIcon'} onClick={onCloseCallback} />
                </div>
            </div>
            {


                //     <Modal.Header closeButton >
                //         <Modal.Title>
                //             {modal.icon}
                //             <span>
                //                 {modal.title}
                //                 <span className="subtitle">
                //                     {modal.subtitle && <><br />{modal.subtitle}</>}
                //                 </span>
                //             </span>
                //         </Modal.Title>

                //      </Modal.Header>
            }

            <div style={modalBodyStyle ? modalBodyStyle : {}} className='modalBody'>
                {children}

            </div>
            {
                //     <Modal.Footer>
                //         <Button variant="secondary" onClick={onCloseCallback}>Voltar</Button>
                //         {modal && modal.submit && <Button variant="primary" onClick={modal.submit}>
                //             {modal.submit_text || 'Salvar'}
                //         </Button>}
                //     </Modal.Footer>
            }
        </Modal>
    )
}
